import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import type {
  AccountData,
  BusinessProfileData,
  BusinessSettings,
  ScheduleData,
  ServicesData,
} from '../types';

interface BusinessSettingsState extends BusinessSettings {
  currentStep: number;
  setAccount: (data: AccountData) => void;
  setProfile: (data: BusinessProfileData) => void;
  setServices: (data: ServicesData) => void;
  setSchedule: (data: ScheduleData) => void;
  setStep: (step: number) => void;
  complete: () => void;
  reset: () => void;
}

const initialData: BusinessSettings & { currentStep: number } = {
  currentStep: 1,
  account: null,
  profile: null,
  services: null,
  schedule: null,
  completedAt: null,
};

export const useBusinessSettingsStore = create<BusinessSettingsState>()(
  persist(
    (set) => ({
      ...initialData,
      setAccount: (data) => set({ account: data }),
      setProfile: (data) => set({ profile: data }),
      setServices: (data) => set({ services: data }),
      setSchedule: (data) => set({ schedule: data }),
      setStep: (step) => set({ currentStep: step }),
      complete: () => set({ completedAt: new Date().toISOString() }),
      reset: () => set(initialData),
    }),
    { name: 'calendo-business-settings' },
  ),
);
